import React from "react";
import "./ArticleCol.css";

const ArticleCol = ({ image, title, body, linkClass, id, link }) => {
  const btnClass = linkClass + ' btn btn-link text-primary p-0';
  const spanClass = linkClass ? 'text-white' : 'hero2link';
  return (
    <div className="content">
        <h1 className="title">
          {title}
        </h1>
        <div dangerouslySetInnerHTML={{ __html: body }} />
        <a href={ link ? link : `/news-post/${id}`}>
          <button className={btnClass}>
            <span className={spanClass}>Find out more</span>
          </button>
        </a>
    </div>
  );
};

export default ArticleCol;


// WEBPACK FOOTER //
// src/components/AritcleCol/ArticleCol.js